<div class="component-container">
  <mat-accordion [multi]="true">
    <mat-expansion-panel [expanded]="true">
      <mat-expansion-panel-header class="nnki-accordion-header">
        <span class="nnki-accordion-title">{{ 'cgu.cgv1' | translate }}</span>
      </mat-expansion-panel-header>
      <div
        [innerHTML]="'cgu.cgv1_content' | translate : { siteDomain: languageService.siteDomain }"
      ></div>
    </mat-expansion-panel>

    <mat-expansion-panel [expanded]="true">
      <mat-expansion-panel-header class="nnki-accordion-header">
        <span class="nnki-accordion-title">{{ 'cgu.cgv2' | translate }}</span>
      </mat-expansion-panel-header>

      <div *ngIf="offers">
        <div [innerHTML]="'cgu.cgv2_content' | translate"></div>
        <div
          *ngFor="let offer of (offers | offersByTier)[SubscriptionTier.PREMIUM_PLUS]"
          [innerHTML]="
            'cgu.cgv2_content2'
              | translate
                : {
                    period: offer.displayedDuration,
                    price: offer.price | number : '1.2-2' : 'fr'
                  }
          "
        ></div>
        <div
          *ngFor="let offer of (offers | offersByTier)[SubscriptionTier.ELITE]"
          [innerHTML]="
            'cgu.cgv2_content3'
              | translate
                : {
                    period: offer.displayedDuration,
                    price: offer.price | number : '1.2-2' : 'fr'
                  }
          "
        ></div>
      </div>
    </mat-expansion-panel>

    <mat-expansion-panel [expanded]="true">
      <mat-expansion-panel-header class="nnki-accordion-header">
        <span class="nnki-accordion-title">{{ 'cgu.cgv3' | translate }}</span>
      </mat-expansion-panel-header>
      <div [innerHTML]="'cgu.cgv3_content' | translate"></div>
    </mat-expansion-panel>

    <mat-expansion-panel [expanded]="true">
      <mat-expansion-panel-header class="nnki-accordion-header">
        <span class="nnki-accordion-title">{{ 'cgu.cgv4' | translate }}</span>
      </mat-expansion-panel-header>
      <div
        [innerHTML]="
          'cgu.cgv4_content' | translate : { intercomEmail: languageService.intercomEmail }
        "
      ></div>
    </mat-expansion-panel>

    <mat-expansion-panel [expanded]="true">
      <mat-expansion-panel-header class="nnki-accordion-header">
        <span class="nnki-accordion-title">{{ 'cgu.cgv5' | translate }}</span>
      </mat-expansion-panel-header>
      <div [innerHTML]="'cgu.cgv5_content' | translate"></div>
    </mat-expansion-panel>

    <mat-expansion-panel [expanded]="true">
      <mat-expansion-panel-header class="nnki-accordion-header">
        <span class="nnki-accordion-title">{{ 'cgu.cgv6' | translate }}</span>
      </mat-expansion-panel-header>
      <div
        [innerHTML]="
          'cgu.cgv6_content' | translate : { intercomEmail: languageService.intercomEmail }
        "
      ></div>
    </mat-expansion-panel>
  </mat-accordion>

  <app-public-footer></app-public-footer>
</div>
